import { cards } from '@/mocks/homeData';
import ImageBox from '@/components/base/ImageBox';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-3">
            热门爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            深度挖掘娱乐圈不为人知的精彩故事，独家视角呈现最劲爆内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((item, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer"
            >
              <ImageBox
                src={item.image}
                alt={item.title}
                title={`吃瓜网51 - ${item.title}`}
                className="relative w-full aspect-[3/2] overflow-hidden bg-background-100"
                imgClassName="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              >
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[11px] font-semibold rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </ImageBox>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 mb-2 font-heading line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}